import { SET_SUGGESTIONS, SELECT_SUGGESTION, SET_SCRIPT_LOADING } from "../actionTypes";
import { handleActions } from 'redux-actions';

const initialState = {
  suggestions: [],
  selected: {
    pick_up: {},
    drop_off: {}
  },
  scriptLoading: false
};

const commonReducer = handleActions (
  {
    [SET_SUGGESTIONS]: (state, { payload }) => ({
      ...state,
      suggestions: payload
    }),
    [SELECT_SUGGESTION]: (state, { payload }) => ({
      ...state,
      selected: {
        ...state.selected,
        [payload.key]: payload.suggestion
      }
    }),
    [SET_SCRIPT_LOADING]: (state, {payload}) => ({
      ...state,
      scriptLoading: payload
    })
  },
  initialState
);

export default commonReducer;